import Modal from "../Modal";
import VendorDetailWarehouseSalesItemForm from "../../forms/vendor/VendorDetailWarehouseSalesItemForm";
import { useTranslation } from "../../../hooks/useTranslation";

export default function VendorDetailWarehouseSaleItemModal({
  show,
  handleClose,
    products,
    setCart,
    setShowModal,
  title,
}) {
  const { t } = useTranslation();
  return (
    <Modal title={title} show={show} handleClose={handleClose} width="700px">
      <VendorDetailWarehouseSalesItemForm
        handleClose={handleClose}
        products={products}
        setCart={setCart}
        setShowModal={setShowModal}
      />
    </Modal>
  );
}
